export const handleScheduleDeletion = async ({
  scheduleId,
  deleteFn,
  handleSuccess,
  handleError,
  setLoading,
  onSuccessMessage = "Schedule deleted successfully.",
  onErrorMessage = "An error occurred while deleting the schedule.",
  reload = true,
}) => {
  if (!scheduleId) {
    handleError("Unexpected error occurred. Please try again later.");
    return;
  }

  try {
    setLoading(true);
    const data = { sch_id: scheduleId };
    await deleteFn(data);
    handleSuccess(onSuccessMessage);
    localStorage.removeItem("selectedSection");
    localStorage.setItem("selectedComponent", "Detailed P&L");

    if (reload) {
      window.location.reload();
    }
  } catch (error) {
    handleError(error.response.data.message || onErrorMessage);
  } finally {
    setLoading(false);
  }
};
